module.exports = __webpack_public_path__ + "img/bold-messages.3be63954.svg";